<template>
  <div
    v-if="isMobileScreenSize"
    class="flex flex-col border rounded w-full p-24 gap-16"
  >
    <div class="flex border border-grey-300 rounded p-16 w-full">
      <select
        :value="getDoctorPreferenceValue(doctor)"
        class="w-full justify-between"
        @change="
          (e) =>
            updatePreferenceOrder({
              oldPreferenceValue: getDoctorPreferenceValue(doctor),
              newPreferenceValue: e.target.value,
            })
        "
      >
        <option :value="0">1st choice</option>
        <option :value="1">2nd choice</option>
        <option :value="2">3rd choice</option>
        <option :value="3">4th choice</option>
      </select>
    </div>

    <div class="flex flex-col gap-16">
      <NameSection :name="doctor.name" :gender="doctor.gender" />
      <ContactInfo
        :clinic="doctor.clinic"
        :address="doctor.address"
        :phone="doctor.phone"
      />
    </div>
    <div class="flex flex-col gap-16 flex-shrink-0 w-full">
      <Body
        >({{
          $t('health_actions.scheduling.select_doctor_distance_miles', [
            doctor.distance,
          ])
        }})</Body
      >
      <div class="flex flex-row justify-end">
        <Icon
          v-if="removable"
          iconClass="fas fa-times-circle text-grey-500 text-2xl cursor-pointer self-end"
          @click="removeSelectedDoctor(doctor)"
        />
      </div>
    </div>
  </div>
  <div v-else class="flex border items-center rounded w-full p-24 gap-48">
    <div
      class="flex items-center border border-grey-300 rounded p-16 flex-shrink-0"
    >
      <select
        :value="getDoctorPreferenceValue(doctor)"
        class="w-full justify-between"
        @change="
          (e) =>
            updatePreferenceOrder({
              oldPreferenceValue: getDoctorPreferenceValue(doctor),
              newPreferenceValue: e.target.value,
            })
        "
      >
        <option :value="0">1st choice</option>
        <option :value="1">2nd choice</option>
        <option :value="2">3rd choice</option>
        <option :value="3">4th choice</option>
      </select>
    </div>
    <div class="flex justify-between w-full">
      <div class="flex flex-col gap-24">
        <NameSection :name="doctor.name" :gender="doctor.gender" />
        <ContactInfo
          :clinic="doctor.clinic"
          :address="doctor.address"
          :phone="doctor.phone"
        />
      </div>
      <Body class="flex-shrink-0"
        >({{
          $t('health_actions.scheduling.select_doctor_distance_miles', [
            doctor.distance,
          ])
        }})</Body
      >
    </div>

    <Icon
      v-if="removable"
      iconClass="fas fa-times-circle text-grey-500 text-2xl cursor-pointer"
      @click="removeSelectedDoctor(doctor)"
    />
  </div>
</template>

<script>
import Icon from '~/components/common/Icon.vue'
import NameSection from './NameSection.vue'
import ContactInfo from './ContactInfoSection.vue'
import screenSizeMixin from '~/components/mixins/screenSizeMixin'
import { mapActions, mapGetters } from 'vuex'
import Body from '~/components/common/Typography/Body.vue'

export default {
  components: { Icon, Body, NameSection, ContactInfo },
  mixins: [screenSizeMixin],
  props: {
    doctor: {
      type: Object,
      required: true,
    },
    removable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('scheduling', ['getDoctorPreferenceValue']),
  },
  methods: {
    ...mapActions('scheduling', [
      'updatePreferenceOrder',
      'removeSelectedDoctor',
    ]),
  },
}
</script>
